<template>
  <qx-empty-data
    :image="placeholder"
    :title="title"
    :description="description" />
</template>

<script>
import QxEmptyData from '@/elements/QxEmptyData';

export default {
  name: 'EmptyFilterResults',
  components: {
    QxEmptyData,
  },
  data() {
    return {
      placeholder: {
        src: '/images/empty/search-result.svg',
        alt: this.$gettext('image no results found'),
      },
      title: this.$gettext('No results found'),
      description: `${this.$gettext('Try different keywords or change the search filters')}.`,
    };
  },
};
</script>
